import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'hover-data-renderer',
  templateUrl: './hover-data-renderer.component.html',
  styleUrls: ['./hover-data-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HoverDataRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParams;   
    public organizations : any = [];
    public details : string;    
    show = false;
    
    
    constructor() {
  
    }
  
    initilize(params: ICellRendererParams) {
      if (params && params.data) {
        this.details = params.data.sales_organization_count.toString();
        this.organizations = params.data.UserSalesOrgAssociation;
      }   
    }

      
    // called on init
    agInit(params: any): void {
      this.initilize(params);
    }
  
    // called when the cell is refreshed
    refresh(params: any): boolean {
      this.initilize(params);
      return true;
    }
   
}